import { type Database } from "@fitness-app/supabase";

export type AppReleaseEntity = Database["public"]["Tables"]["app_release"]["Row"];

export const MOBILE_UPDATE_TYPES = ["ota", "store"] as const;
export type MobileUpdateType = (typeof MOBILE_UPDATE_TYPES)[number];

// Values mirror the DB check() constraint on app_release.platform and the
// AppVersionByPlatform keys of the app_version config row.
export enum AppReleasePlatform {
  Ios = "ios",
  Android = "android",
  Web = "web",
  Admin = "admin",
}

export const APP_RELEASE_PLATFORM_LABELS: Record<AppReleasePlatform, string> = {
  [AppReleasePlatform.Ios]: "iOS",
  [AppReleasePlatform.Android]: "Android",
  [AppReleasePlatform.Web]: "Web",
  [AppReleasePlatform.Admin]: "Panel",
};

export interface AppRelease extends Omit<AppReleaseEntity, "platform"> {
  platform: AppReleasePlatform;
}
